module.exports = __webpack_public_path__ + "static/media/asan-search.512709ea.svg";